<template>
  <select class="form-control m-input" @select="emitChangeEvent" @change="emitChangeEvent">
    <option value="">{{ firstOption }}</option>
    <option
      v-for="service in selects"
      :key="service.id"
      :value="service.id"
      :selected="service.id == selected"
      >{{ service.type }}</option
    >
  </select>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  name: 'SelectProductServices',
  data() {
    return {
      firstOption: this.first ? this.first : 'Todos',
      selects: [],
    };
  },
  props: {
    selected: {
      type: [Number, String],
    },
    first: {
      type: String,
    },
    productId: {
      type: [Number, String],
    },
    getCountable: {
      type: [Number, String],
    },
    servicesSelected: {
      type: Array,
    },
  },
  methods: {
    getData(productId, getCountable) {
      axios(
        `${baseApiUrl}/v1/detail/list?productId=${productId}&isRecurrent=1&isUnique=0&getCountable=${getCountable}`
      ).then((res) => {
        function filterService(service, servicesSelected) {
          let selected = servicesSelected.map((selected) => {
            return selected.serviceId;
          });
          return selected.indexOf(service.id.toString()) == -1;
        }

        if (this.servicesSelected && this.servicesSelected[0].serviceId) {
          let data = res.data.filter((service) => {
            return filterService(service, this.servicesSelected);
          });
          this.selects = data;
        } else {
          this.selects = res.data;
        }
      });
    },
    emitChangeEvent(variable) {
      this.$emit('change', variable.target.value);
    },
  },
  mounted() {
    if (this.productId) {
      this.getData(this.productId, this.getCountable);
    }
  },
  watch: {
    productId(newVal) {
      this.getData(newVal, this.getCountable);
    },
  },
};
</script>
